import React, { InputHTMLAttributes, forwardRef } from "react";
import { Button } from "@/shared/ui/Button";
import { Icon } from "@/shared/ui/Icon";
import { cn } from "@/shared/utils/shadcn";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  setValue?: (value: string) => void;
  small?: boolean;
  large?: boolean;
  noBorder?: boolean;
  white?: boolean;
  deleteIcon?: boolean;
  fullWidth?: boolean;
  paddingRight?: boolean;
  icon?: string;
  active?: boolean;
}

const Field = forwardRef<HTMLInputElement, FieldProps>(
  (
    {
      setValue,
      small,
      large,
      noBorder,
      white,
      deleteIcon,
      fullWidth,
      paddingRight,
      icon,
      active,
      ...inputProps
    },
    ref
  ) => {
    const handleSetValue = (value: string) => {
      if (setValue) {
        setValue(value);
      }
    };

    return (
      <div
        className={cn(
          "relative flex items-center",
          small && "text-sm",
          large && "text-lg",
          white && "bg-white",
          fullWidth && "w-full",
          paddingRight && "pr-4",
          icon && "pl-10",
          noBorder && "border-none",
          inputProps.value &&
            inputProps.value.toString().length > 0 &&
            "writing",
          inputProps.disabled && "opacity-50 cursor-not-allowed"
        )}
      >
        {icon && (
          <div className="absolute left-0 pl-3">
            <i className={icon} />
          </div>
        )}
        <input
          ref={ref}
          className={cn(
            "w-full py-2 px-3 border border-gray-300 rounded outline-none focus:border-gray-500",
            noBorder && "border-none",
            white && "bg-white",
            inputProps.disabled && "opacity-50 cursor-not-allowed"
          )}
          {...inputProps}
        />
        {deleteIcon &&
          inputProps.value &&
          inputProps.value.toString().length > 0 && (
            <div className="absolute right-0 pr-3">
              <Button variant="ghost" onClick={() => handleSetValue("")}>
                <Icon icon="Close" color="grey" />
              </Button>
            </div>
          )}
      </div>
    );
  }
);

Field.displayName = "Field";

export default Field;
